import { zIdName } from "src/types/ZIdName";
import { zUid } from "src/types/zUid";
import z from "zod";

export type Bom3Filter = {};

export const zPermission = z.enum([
  "CREATE",
  "VIEW",
  "UPDATE",
  "UPDATE_STATE",
  "DELETE",
]);
export type ZPermission = z.infer<typeof zPermission>;

export const zBom3 = z.object({
  id: zUid,
  state: zIdName.optional(),
  name: z.string(),
  sizeLineId: zUid.nullish(),
  sizeLineName: z.string().nullish(),
  totalAmount: z.number().nullish(),

  createdDate: z.string().optional(), // "2026-04-29T12:42:22.759Z",
  updatedDate: z.string().optional(), // "2026-04-29T12:42:22.760Z",
  createdBy: z.string().optional(),
  updatedBy: z.string().optional(),
  permissions: zPermission.array().optional(),
});
export type ZBom3 = z.infer<typeof zBom3>;
